export default __webpack_public_path__ + "static/media/icare-logo-big.07d60f01.png";